export class Foto {
	IdNoticia: string;
	Id: string;
	IdFotoExt: string;
	IdContenidoWebExterna: string;
	IdContenido: string;
	IdBaliza: string;
	IdNodo: string;
	IdEspacio: string;
	IdRutaSugerida: string;
	UrlFotoExt: string;
	IdAvisoCiudadano: string;
	IdFotoExt_detalle: string;
	UrlFotoExt_detalle: string;
	Tipo: number;
	Orden: number;
	File: any;
	ENTIDAD: any;

    constructor(){}

	fromENTIDAD(ENTIDAD: any): Foto{

		this.ENTIDAD = ENTIDAD;
		this.Id = this.ENTIDAD.Id;
		this.IdFotoExt = this.ENTIDAD.IdFotoExt;
		this.IdFotoExt_detalle = this.ENTIDAD.IdFotoExt_detalle;
		this.UrlFotoExt = this.ENTIDAD.UrlFotoExt;
		this.UrlFotoExt_detalle = this.ENTIDAD.UrlFotoExt_detalle;
		this.Tipo = this.ENTIDAD.Tipo;
		this.Orden = this.ENTIDAD.Orden;
		this.File = this.ENTIDAD.File;

		this.IdContenido = this.ENTIDAD.IdContenido;
		this.IdContenidoWebExterna = this.ENTIDAD.IdContenidoWebExterna;
		this.IdEspacio = this.ENTIDAD.IdEspacio;
		this.IdRutaSugerida = this.ENTIDAD.IdRutaSugerida;
		this.IdAvisoCiudadano = this.ENTIDAD.IdAvisoCiudadano;

		this.IdNodo = this.ENTIDAD.IdNodo;
		this.IdBaliza = this.ENTIDAD.IdBaliza;
		this.IdNoticia = this.ENTIDAD.IdNoticia;

		return this;
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/Foto.ts